import { Suspense } from 'react';
import { Box, CircularProgress, Tab, Tabs, Typography } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const SUBNAV = [
  { path: '/innsikt/leder', label: 'Ledelse' },
  { path: '/innsikt/risiko', label: 'Risiko' },
  { path: '/innsikt/dekning', label: 'Dekning & avstemming' },
  { path: '/innsikt/flyt', label: 'Inntektsflyt' },
];

export function InnsiktLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const current = SUBNAV.findIndex((s) => location.pathname.startsWith(s.path));

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 1 }}>Innsikt</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Visuell oversikt over inntektsgrunnlaget — dekning, risiko, avvik og pengestrømmer.
      </Typography>
      <Tabs
        value={current === -1 ? 0 : current}
        onChange={(_e, v) => navigate(SUBNAV[v].path)}
        sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
        aria-label="Innsikt-faner"
      >
        {SUBNAV.map((s) => (
          <Tab key={s.path} label={s.label} />
        ))}
      </Tabs>
      <Suspense fallback={<Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>}>
        <Outlet />
      </Suspense>
    </Box>
  );
}
